export const translations = {
  sr: {
    nav: {
      home: "Početna",
      services: "Usluge",
      gallery: "Galerija",
      contact: "Kontakt"
    },
    hero: {
      tagline: "GRADNJA & RENOVACIJE",
      title: "Gradimo Vaše Snove",
      subtitle: "Od temelja do krova",
      description: "Više od 20 godina iskustva u građevinarstvu. Kvalitetna gradnja, pouzdanost i profesionalan pristup svakom projektu.",
      cta_contact: "Kontaktirajte Nas",
      cta_services: "Naše Usluge"
    },
    about: {
      tagline: "O NAMA",
      title: "Rade Gradnja STD",
      description: "Građevinska firma sa tradicijom kvaliteta i pouzdanosti od 2004. godine. Specijalizovani smo za sve vrste građevinskih radova - od malih renovacija do kompletne izgradnje objekata po sistemu ključ u ruke.",
      experience: "Godina iskustva",
      projects: "Završenih Projekata",
      clients: "Zadovoljnih Klijenata",
      area: "Područje Rada"
    },
    services: {
      tagline: "NAŠE USLUGE",
      title: "Šta Radimo",
      subtitle: "Nudimo širok spektar građevinskih usluga prilagođenih vašim potrebama",
      turnkey: {
        title: "Ključ u Ruke",
        description: "Kompletna izgradnja, od sna do ključa u vašim rukama."
      },
      construction: {
        title: "Siva Gradnja",
        description: "Temelji, zidovi, ploče, krovne konstrukcije - osnova za svaki objekat."
      },
      pools: {
        title: "Bazeni",
        description: "Projektovanje i izgradnja bazena svih veličina i oblika za vaše dvorište."
      },
      gazebos: {
        title: "Letnjikovci",
        description: "Elegantni letnjikovci za uživanje na otvorenom tokom cele godine."
      },
      garages: {
        title: "Garaže",
        description: "Funkcionalne i estetski uklopljene garaže za vaša vozila."
      },
      terraces: {
        title: "Terase",
        description: "Moderne terase koje proširuju vaš životni prostor na otvoreno."
      },
      drainage: {
        title: "Drenaže",
        description: "Profesionalni drenažni sistemi za zaštitu vašeg objekta od vlage."
      },
      insulation: {
        title: "Izolacije",
        description: "Sve vrste termičke, hidro i zvučne izolacije za maksimalnu udobnost."
      }
    },
    gallery: {
      tagline: "GALERIJA",
      title: "Naši Radovi",
      subtitle: "Pogledajte neke od projekata koje smo realizovali",
      all: "Svi Radovi",
      houses: "Kuće",
      pools: "Bazeni",
      garages: "Garaže",
      terraces: "Terase",
      gazebos: "Letnjikovci"
    },
    contact: {
      tagline: "KONTAKT",
      title: "Javite Nam Se",
      subtitle: "Imate pitanja ili želite ponudu? Kontaktirajte nas!",
      form: {
        name: "Vaše Ime",
        email: "Email Adresa",
        phone: "Broj Telefona",
        message: "Vaša Poruka",
        send: "Pošaljite Poruku",
        sending: "Šalje se...",
        success: "Poruka uspešno poslata!",
        error: "Greška pri slanju. Pokušajte ponovo."
      },
      info: {
        phone: "Telefon",
        email: "Email",
        address: "Adresa",
        viber: "Viber"
      },
      area: {
        title: "Područje Rada",
        description: "Radovi se izvode na području Gornjeg Milanovca i okoline, a po dogovoru i na teritoriji cele Srbije."
      }
    },
    footer: {
      description: "Vaš pouzdan partner za sve građevinske radove. Kvalitet, pouzdanost i profesionalnost od 2004. godine.",
      quickLinks: "Brzi Linkovi",
      contact: "Kontakt",
      rights: "Sva prava zadržana."
    }
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      gallery: "Gallery",
      contact: "Contact"
    },
    hero: {
      tagline: "CONSTRUCTION & RENOVATION",
      title: "Building Your Dreams",
      subtitle: "From foundation to roof",
      description: "Over 20 years of experience in construction. Quality building, reliability and professional approach to every project.",
      cta_contact: "Contact Us",
      cta_services: "Our Services"
    },
    about: {
      tagline: "ABOUT US",
      title: "Rade Gradnja STD",
      description: "A construction company with a tradition of quality and reliability since 2004. We specialize in all types of construction work - from small renovations to complete turnkey building construction.",
      experience: "Years of Experience",
      projects: "Completed Projects",
      clients: "Satisfied Clients",
      area: "Work Area"
    },
    services: {
      tagline: "OUR SERVICES",
      title: "What We Do",
      subtitle: "We offer a wide range of construction services tailored to your needs",
      turnkey: {
        title: "Turnkey",
        description: "Complete construction, from dream to keys in your hands."
      },
      construction: {
        title: "Structural Work",
        description: "Foundations, walls, slabs, roof structures - the foundation for every building."
      },
      pools: {
        title: "Pools",
        description: "Design and construction of pools of all sizes and shapes for your yard."
      },
      gazebos: {
        title: "Gazebos",
        description: "Elegant gazebos for outdoor enjoyment throughout the year."
      },
      garages: {
        title: "Garages",
        description: "Functional and aesthetically integrated garages for your vehicles."
      },
      terraces: {
        title: "Terraces",
        description: "Modern terraces that extend your living space outdoors."
      },
      drainage: {
        title: "Drainage",
        description: "Professional drainage systems to protect your building from moisture."
      },
      insulation: {
        title: "Insulation",
        description: "All types of thermal, hydro and sound insulation for maximum comfort."
      }
    },
    gallery: {
      tagline: "GALLERY",
      title: "Our Work",
      subtitle: "Check out some of the projects we have completed",
      all: "All Works",
      houses: "Houses",
      pools: "Pools",
      garages: "Garages",
      terraces: "Terraces",
      gazebos: "Gazebos"
    },
    contact: {
      tagline: "CONTACT",
      title: "Get In Touch",
      subtitle: "Have questions or want a quote? Contact us!",
      form: {
        name: "Your Name",
        email: "Email Address",
        phone: "Phone Number",
        message: "Your Message",
        send: "Send Message",
        sending: "Sending...",
        success: "Message sent successfully!",
        error: "Error sending. Please try again."
      },
      info: {
        phone: "Phone",
        email: "Email",
        address: "Address",
        viber: "Viber"
      },
      area: {
        title: "Work Area",
        description: "Work is carried out in the Gornji Milanovac area and surroundings, and by agreement throughout Serbia."
      }
    },
    footer: {
      description: "Your reliable partner for all construction work. Quality, reliability and professionalism since 2004.",
      quickLinks: "Quick Links",
      contact: "Contact",
      rights: "All rights reserved."
    }
  }
};
